import { scheduleIdle } from '@/shared/utils/scheduleIdle';

declare const __SENTRY_RELEASE__: string;

export function setupSentry(): void {
  if (process.env.NODE_ENV !== 'production') return;

  scheduleIdle(() => {
    void import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: "https://74a20edced080f332a92a14f35992310@o4510770740592640.ingest.us.sentry.io/4510770749964288",
        sendDefaultPii: true,
        release: __SENTRY_RELEASE__,
      });
    });
  });
}
